import { Loading } from 'components/core-v2/pages'

import { ScenarioPoint, useGetByTenantScenariosLatestAllassetsladderQuery } from '../../../api'
import { SelectField } from '../../../components/core-v2'
import ScenarioTable from '../../../components/core-v2/organisms/scenario-table'
import { TENANT } from '../../../const'

const FILTER_VALUES = ['assets', 'fund-managers']
const FILTER_OPTIONS = [
  { label: 'Assets', value: FILTER_VALUES[0] },
  { label: 'Fund Managers', value: FILTER_VALUES[1] }
]

export type ScenarioStatelessProps = {
  data: Record<string, ScenarioPoint[]>
  isLoading: boolean
  onAssetClick: (assetId: string) => void
}

const ScenarioStateless = ({ data = {}, isLoading, onAssetClick }: ScenarioStatelessProps) => {
  const scenarioData = Object.keys(data).map(item => ({ isinCode: item, values: data[item] }))
  const { data: allAssetsLadderData, isLoading: isAllAssetsLadder } =
    useGetByTenantScenariosLatestAllassetsladderQuery({
      tenant: TENANT
    })

  return isLoading || isAllAssetsLadder ? (
    <Loading className="mt-12" />
  ) : (
    <>
      <div className="mt-half mb-1 d-flex">
        <SelectField className="mr-8" id="filter" label="Shock filter" options={FILTER_OPTIONS} />
      </div>
      <ScenarioTable
        allAssetsLadderData={allAssetsLadderData}
        data={scenarioData}
        onAssetClick={onAssetClick}
        onRowClick={row => onAssetClick(row.isinCode)}
      />
    </>
  )
}

export default ScenarioStateless
